import axios from "axios";

const API_URLS = {
  dev: "http://10.40.1.99:8000",
  prod: "https://dev-carrier-user.globtel.biz/api",
};

const getApiUrl = () => {
  if (process.env.NODE_ENV !== "production") return API_URLS.dev;
  if (process.env.REACT_APP_DEV_BUILD === "true") return API_URLS.dev;
  return API_URLS.prod;
};

export const apiClient = axios.create({
  baseURL: getApiUrl(),
});

apiClient.interceptors.request.use((config) => {
  const token = localStorage.getItem("token");
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }

  return config;
});

const handleError = (error) => {
  const status = error.response?.status;
  const url = error.config?.url || "";

  if (
    status === 401 &&
    !url.includes("/auth/login") &&
    !url.includes("/auth/verify-login-app") &&
    !url.includes("auth/verify-login-email")
  ) {
    localStorage.removeItem("token");

    // Pobieramy język ze ścieżki lub localStorage
    const pathParts = window.location.pathname.split("/").filter(Boolean);
    const langFromPath = pathParts.length > 0 ? pathParts[0] : null;
    const currentLang = langFromPath || localStorage.getItem("i18nextLng") || "en";

    window.location.href = `/${currentLang}/sign-in`;
    return Promise.reject(error);
  }

  if (!error.response?.status && error.request) {
    error.status = error.request.status;
    error.response = {
      status: error.request.status,
      data: error.response?.data || {},
    };
  }

  return Promise.reject(error);
};

apiClient.interceptors.response.use((response) => response, handleError);

export default apiClient;
